module.exports = __webpack_public_path__ + "img/footTwo.7d5a44d3.png";